import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequest,
  getRequestWithParams,
  getRequestWithApiKey,
  getRequestWithParamsAndApiKey,
} from "../../services/API";

const COUNTRY_LIST = "countryList";
const STATE_LIST = "stateList";
const CMS_LIST = "getCMSList";
const CMS_BY_KEY = "getCMSByKey";

export const countryList = createAsyncThunk(
  COUNTRY_LIST,
  async ({ language }, { rejectWithValue }) => {
    try {
      let countryResult = await getRequest(language, "country", false);
      return countryResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

// get states

export const stateList = createAsyncThunk(
  STATE_LIST,
  async (
    { language, selectedKey },
    { rejectWithValue }
  ) => {
    try {
      let countryResult = await getRequestWithParams(
        language,
        "province",
        selectedKey,
        false
      );
      return countryResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

// get CMS details

export const getCMSList = createAsyncThunk(
  CMS_LIST,
  async ({ language }, { rejectWithValue }) => {
    try {
      // Use API key for CMS requests (public content)
      let cmsResult = await getRequestWithApiKey(language, "cms");
      return cmsResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

export const getCMSByKey = createAsyncThunk(
  CMS_BY_KEY,
  async ({ language, key }, { rejectWithValue }) => {
    try {
      let cmsResult = await getRequestWithParamsAndApiKey(
        language,
        "cms",
        `/key/${key}`
      );
      return cmsResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
